import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-load-info',
  templateUrl: './load-info.component.html',
  styleUrls: ['./load-info.component.sass']
})
export class LoadInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
